import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export type KeyCommunityProps = {
  id: number;
};

export const keyCommunitiesAdminCommunity: BaseKeyFunction<
  KeyCommunityProps
> = ({ id }) => ["communities-admin-community", id.toString()];
